// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"landingCards_cardContainer__1PhHA","cardIcon":"landingCards_cardIcon__CjRve","cardLink":"landingCards_cardLink__eMtd-"};